import React from 'react';
import { UserPlus, CalendarCheck, Users, HeartPulse } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const audiences = [{
  icon: UserPlus,
  title: 'Personas celíacas recién diagnosticadas',
  desc: 'Que necesitan una guía clara y práctica.'
}, {
  icon: CalendarCheck,
  title: 'Personas que quieren organizar su alimentación',
  desc: 'Sin estrés y sin perder tiempo.'
}, {
  icon: Users,
  title: 'Familias con integrantes celíacos',
  desc: 'Que buscan comidas saludables para todos.'
}, {
  icon: HeartPulse,
  title: 'Personas que quieren sentirse mejor físicamente',
  desc: 'Con más energía y mejor digestión.'
}];
export function TargetAudience() {
  return <section className="py-20 bg-white" data-id="element-206">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-207">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-208">
          <FadeIn data-id="element-209">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-950 mb-4" data-id="element-210">
              ¿PARA QUIÉN ES?
            </h2>
            <p className="text-lg text-brand-700" data-id="element-211">
              Diseñado para personas que quieren mejorar su vida sin gluten
            </p>
          </FadeIn>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-212">
          {audiences.map((item, idx) => {
          const Icon = item.icon;
          return <FadeIn key={idx} delay={idx * 0.1} className="flex gap-6 p-6 rounded-3xl bg-cream-200 hover:bg-brand-50 transition-colors border border-transparent hover:border-brand-100 group" data-id="element-213">
                <div className="w-14 h-14 bg-white rounded-2xl flex items-center justify-center flex-shrink-0 shadow-sm group-hover:scale-110 transition-transform" data-id="element-214">
                  <Icon className="w-7 h-7 text-brand-500" data-id="element-215" />
                </div>
                <div data-id="element-216">
                  <h3 className="text-xl font-bold text-brand-950 mb-2" data-id="element-217">
                    {item.title}
                  </h3>
                  <p className="text-brand-700" data-id="element-218">{item.desc}</p>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}